"use client"

import { useBaseBetslip, useChain, useDetailedBetslip } from "@azuro-org/sdk"
import { Message } from "@locmod/intl"
import dynamic from "next/dynamic"
import { openModal } from "@locmod/modal"
import React, { useEffect } from "react"

import { Icon } from "components/ui"

import messages from "./messages"

const SelectFreeBetModal = dynamic(
  () => import("./components/SelectFreeBetModal/SelectFreeBetModal")
)

const SelectFreeBet: React.FC = () => {
  const { betToken } = useChain()
  const { items } = useBaseBetslip()
  const { freebets, selectedFreebet, selectFreebet, isFreebetsFetching } =
    useDetailedBetslip()

  const clearFreebet = () => {
    selectFreebet(undefined)
  }

  useEffect(() => {
    if (selectedFreebet) {
      clearFreebet()
    }
  }, [items])

  if (!freebets?.length && !isFreebetsFetching) {
    return null
  }

  return (
    <>
      <div className="-mx-2 border-t border-t-accent-grey-700 group bg-accent-grey-900 relative z-10">
        {Boolean(selectedFreebet) ? (
          <div className="py-2 px-5 flex items-center justify-between text-caption-13 font-semibold">
            <div className="flex items-center text-accent-green-500">
              <Icon className="size-4" name="interface/gift" />
              <Message className="uppercase mx-1" value={messages.freebet} />
            </div>
            <div className="flex items-center">
              <div className="mr-1">
                {selectedFreebet!.amount} {betToken.symbol}
              </div>
              <button onClick={clearFreebet}>
                <Icon
                  className="size-5 text-accent-grey-400 hover:text-accent-grey-30"
                  name="interface/clear"
                />
              </button>
            </div>
          </div>
        ) : (
          <button
            className="py-2 px-5 flex items-center justify-between text-accent-grey-200 group-hover:text-accent-grey-30 w-full"
            onClick={() => openModal("SelectFreeBetModal")}
            disabled={isFreebetsFetching}
          >
            <Message className="text-caption-12" value={messages.apply} />
            <Icon
              className="size-5"
              name={
                isFreebetsFetching
                  ? "interface/spinner"
                  : "interface/chevron_right"
              }
            />
          </button>
        )}
      </div>
      <SelectFreeBetModal />
    </>
  )
}

export default SelectFreeBet
